import { AriaPopover, Stack, useText, Text } from "@sveabank/cc-common";
import { usePageContext } from "../../hooks/context";
import { useChoosePackage } from "./hooks";

const BankgiroHeader = () => {
	const [t, texts] = useText();

	const { selectedPackageId } = usePageContext(useChoosePackage);
	const hasChosenBasPackage = selectedPackageId === "BAAS-FÖRETAG-BAS";

	return (
		<Stack align="center" direction="row">
			<Stack direction="row" gap={4}>
				<Text className="text-text-headline text-2xl font-bold">
					{t(texts.choosePackage.companyAccount.heading)}
				</Text>

				{hasChosenBasPackage && (
					<AriaPopover
						variant="info"
						content={() => t(texts.choosePackage.companyAccount.tooltip)}
					/>
				)}
			</Stack>
		</Stack>
	);
};

export default BankgiroHeader;
